import { useNavigate, useRoutes } from "react-router-dom";
import back_icn_btn from "../../assets/Demat/back_icn_btn.svg";


export default function BackButton(){
    const navigate = useNavigate()

    function stepBack(){
        navigate(-1)
    }

    return      <div className="headerBtnIPODetails">
    <button
      type="button"
      name="button"
      className="  btncolor small-btn"
      onClick={stepBack}
    >
      <img src={back_icn_btn} /> Back
    </button>
  </div>

}